import { fetchEncryptGet } from '#providers/Fetch';
import makeHandler from '#services/makeHandler';

const URL = {
  getAll: 'poi',
};

const getAll = makeHandler(async (query = {}) => fetchEncryptGet(URL.getAll, query),
  { defaultError: 'Error fetching pois' });

export default {
  getAll,
};
